__webpack_require__.p = "/personal-tokens-lib/referrals/";